import { useAuthStore } from '@/stores/auth';

export const forbidToAuthorized = () => {
  const authStore = useAuthStore();

  return authStore.isAuthorized.value ? { name: 'root' } : true;
};
